export interface NewsArticle {
  id: string;
  title: string;
  summary: string;
  content: string;
  category: string;
  tags: string[];
  author: string;
  authorAvatar: string;
  publishDate: string;
  readTime: number;
  views: number;
  cover: string;
  featured?: boolean;
}

export const NEWS_CATEGORIES = [
  { id: 'all', label: '全部' },
  { id: 'metaverse', label: '元宇宙' },
  { id: '6g', label: '6G/通信' },
  { id: 'web3', label: 'Web3/Web5' },
  { id: 'xr', label: 'XR体验' },
  { id: 'digital-economy', label: '数字经济' },
  { id: 'ai', label: 'AI智能体' },
  { id: 'quantum', label: '量子科技' },
];

export const NEWS_ARTICLES: NewsArticle[] = [
  {
    id: 'meta66-001',
    title: 'META66宣布完成D轮融资，估值突破500亿，加速全球元宇宙生态布局',
    summary: 'META66平台完成由红杉资本领投、a16z跟投的D轮融资，融资总额达18亿美元，本轮资金将用于6G基础设施建设、Web5.0协议研发及全球生态节点扩张。',
    content: `META66今日正式宣布完成D轮融资，本轮融资由红杉资本领投，a16z、软银愿景基金、淡马锡等顶级机构跟投，融资总额达18亿美元，投后估值突破500亿人民币。

这是迄今为止中国元宇宙领域最大规模的单轮融资，标志着META66在全球元宇宙赛道的领先地位得到国际顶级资本的高度认可。

**资金用途规划**

本轮融资将主要用于以下三大方向：

一、6G基础设施建设：META66将与全球主要电信运营商合作，在亚太、欧洲、北美三大区域部署超过50个6G元宇宙专属节点，实现亚毫秒级延迟的沉浸式体验。

二、Web5.0协议研发：加速推进META66自主研发的MetaProtocol 5.0去中心化协议栈，预计2026年Q3正式发布，将支持每秒百万级并发用户的元宇宙空间交互。

三、全球生态节点扩张：在现有128个全球节点基础上，新增200个战略节点，覆盖全球80个主要城市，构建真正意义上的全球元宇宙基础设施网络。

**CEO发言**

META66创始人兼CEO表示："这轮融资不仅是资本的认可，更是对我们技术路线和生态战略的高度肯定。我们相信，元宇宙不是一个遥远的概念，而是正在发生的现实。META66将以6G超连接为基础，以Web5.0为协议框架，以XR沉浸体验为入口，构建人类数字文明的下一个形态。"

**行业影响**

业内分析人士认为，META66此次融资将进一步加速中国元宇宙产业的整体发展进程，预计将带动上下游产业链超过1000亿元的投资规模。`,
    category: 'metaverse',
    tags: ['融资', '元宇宙', '6G', 'Web5.0'],
    author: 'META66编辑部',
    authorAvatar: 'https://public.readdy.ai/ai/img_res/f85c4a3f680275a7088062069966bf93.jpg',
    publishDate: '2026-04-01',
    readTime: 8,
    views: 128600,
    cover: 'https://readdy.ai/api/search-image?query=metaverse%20investment%20funding%20announcement%20holographic%20green%20neon%20digital%20city%20futuristic%20sci-fi%20dark%20background%20cinematic%20wide&width=1200&height=630&seq=news-cover-001&orientation=landscape',
    featured: true,
  },
  {
    id: 'meta66-002',
    title: '6G商用元年：META66发布全球首个元宇宙专属6G网络切片方案',
    summary: '在2026世界移动通信大会上，META66联合华为、爱立信发布MetaSlice 6G网络切片技术，实现0.1ms超低延迟，为元宇宙沉浸体验提供革命性网络保障。',
    content: `在2026年世界移动通信大会（MWC 2026）上，META66联合华为、爱立信正式发布MetaSlice 6G网络切片技术方案，这是全球首个专为元宇宙场景设计的6G网络切片解决方案。

MetaSlice技术实现了以下突破性指标：
- 端到端延迟：0.1ms（较4G降低1000倍）
- 峰值速率：100Gbps
- 连接密度：每平方公里100万设备
- 可靠性：99.99999%（七个9）

这意味着用户在元宇宙中的每一个动作、每一帧画面都能以接近光速的速度传输，真正实现"感知不到延迟"的沉浸式体验。

META66技术总监表示，MetaSlice将于2026年Q4在深圳、上海、北京三个城市率先商用，预计2027年覆盖全国50个主要城市。`,
    category: '6g',
    tags: ['6G', '网络切片', '元宇宙', '华为'],
    author: '张明远',
    authorAvatar: 'https://readdy.ai/api/search-image?query=tech%20writer%20male%20portrait%20professional%20dark%20background%20green%20accent&width=80&height=80&seq=avatar-002&orientation=squarish',
    publishDate: '2026-03-28',
    readTime: 6,
    views: 86400,
    cover: 'https://readdy.ai/api/search-image?query=6G%20network%20tower%20signal%20waves%20glowing%20green%20neon%20dark%20background%20futuristic%20technology%20cinematic%20sci-fi&width=1200&height=630&seq=news-cover-002&orientation=landscape',
    featured: true,
  },
  {
    id: 'meta66-003',
    title: 'Web5.0时代来临：去中心化身份协议DID 3.0正式纳入META66生态标准',
    summary: 'W3C与META66联合宣布，去中心化身份协议DID 3.0正式成为META66元宇宙生态的身份认证标准，用户将真正拥有跨平台、不可剥夺的数字身份主权。',
    content: `W3C（万维网联盟）与META66今日联合宣布，去中心化身份协议DID（Decentralized Identifiers）3.0正式成为META66元宇宙生态的统一身份认证标准。

这一里程碑意义重大：在Web5.0时代，用户的数字身份将不再由任何中心化平台控制，而是完全由用户自己掌握。无论是在META66的虚拟空间、数字资产交易市场，还是跨平台的元宇宙体验，用户都将使用同一个不可篡改、不可剥夺的数字身份。

DID 3.0的核心特性包括：
- 零知识证明身份验证，保护隐私的同时确保真实性
- 跨链兼容，支持以太坊、Solana、Polkadot等主流区块链
- 生物特征绑定，支持虹膜、声纹、脑波等多模态生物识别
- 量子抗性加密，抵御未来量子计算机的攻击

META66生态内已有超过3200万用户将迁移至DID 3.0标准，成为全球最大的去中心化身份生态。`,
    category: 'web3',
    tags: ['Web5.0', 'DID', '去中心化', '身份主权'],
    author: '李晓雯',
    authorAvatar: 'https://readdy.ai/api/search-image?query=female%20tech%20journalist%20portrait%20professional%20dark%20background%20green%20neon%20accent&width=80&height=80&seq=avatar-003&orientation=squarish',
    publishDate: '2026-03-25',
    readTime: 7,
    views: 64200,
    cover: 'https://readdy.ai/api/search-image?query=web5%20decentralized%20identity%20blockchain%20network%20nodes%20glowing%20green%20dark%20background%20futuristic%20technology%20digital&width=1200&height=630&seq=news-cover-003&orientation=landscape',
  },
  {
    id: 'meta66-004',
    title: 'META66 XR旗舰设备MetaLens Pro发布：重量仅38克，续航12小时',
    summary: 'META66发布新一代XR旗舰设备MetaLens Pro，采用自研芯片MetaChip X1，重量仅38克，续航12小时，视场角达到人眼极限的220度，售价6999元。',
    content: `META66今日在深圳META66元宇宙大厦举办新品发布会，正式发布新一代XR旗舰设备MetaLens Pro。

MetaLens Pro是目前全球最轻薄的全功能XR眼镜，主要参数如下：

**硬件规格**
- 重量：38克（较上代减轻42%）
- 续航：12小时（正常使用）/ 18小时（轻度使用）
- 视场角：220度（水平）/ 180度（垂直）
- 分辨率：每眼8K，120Hz刷新率
- 处理器：META66自研MetaChip X1（3nm工艺）
- 存储：256GB / 512GB可选

**核心技术突破**
MetaLens Pro搭载META66自研的MetaChip X1处理器，采用台积电3nm工艺，集成了专为XR场景优化的神经网络加速单元，可实时处理每秒超过10万亿次的空间计算任务。

**价格与上市时间**
MetaLens Pro将于2026年5月1日正式开售，256GB版本售价6999元，512GB版本售价8999元。`,
    category: 'xr',
    tags: ['XR', '元宇宙眼镜', '硬件', 'MetaLens'],
    author: '王浩然',
    authorAvatar: 'https://readdy.ai/api/search-image?query=male%20tech%20reviewer%20portrait%20professional%20dark%20background%20green%20accent%20futuristic&width=80&height=80&seq=avatar-004&orientation=squarish',
    publishDate: '2026-03-20',
    readTime: 5,
    views: 92100,
    cover: 'https://readdy.ai/api/search-image?query=XR%20augmented%20reality%20glasses%20futuristic%20sleek%20design%20green%20neon%20glow%20dark%20background%20product%20shot%20cinematic&width=1200&height=630&seq=news-cover-004&orientation=landscape',
    featured: true,
  },
  {
    id: 'meta66-005',
    title: '数字人民币与元宇宙深度融合：META66数字经济生态交易额突破万亿',
    summary: '中国人民银行与META66签署战略合作协议，数字人民币正式接入META66元宇宙经济体系，平台数字经济生态年交易额突破1万亿元人民币。',
    content: `中国人民银行数字货币研究所与META66今日签署战略合作协议，数字人民币（e-CNY）正式全面接入META66元宇宙经济体系，这标志着中国数字经济与元宇宙的深度融合进入新阶段。

根据协议，META66平台内的所有数字资产交易、虚拟服务购买、创作者收益结算均可使用数字人民币完成，同时支持与平台原生代币META Token的双向兑换。

**里程碑数据**
META66平台数字经济生态年交易额正式突破1万亿元人民币，成为全球首个年交易额过万亿的元宇宙经济体。其中：
- 数字资产（NFT/虚拟土地/数字藏品）：3200亿元
- 虚拟服务（教育/娱乐/社交/商务）：4800亿元
- 创作者经济（内容/工具/体验）：2000亿元

**行业意义**
这一数据证明，元宇宙经济已不再是概念，而是真实存在的、具有巨大规模的数字经济形态。META66正在成为中国数字经济的重要基础设施。`,
    category: 'digital-economy',
    tags: ['数字经济', '数字人民币', 'NFT', '元宇宙经济'],
    author: '陈思远',
    authorAvatar: 'https://readdy.ai/api/search-image?query=financial%20analyst%20portrait%20professional%20dark%20background%20green%20neon%20accent&width=80&height=80&seq=avatar-005&orientation=squarish',
    publishDate: '2026-03-15',
    readTime: 9,
    views: 55800,
    cover: 'https://readdy.ai/api/search-image?query=digital%20economy%20metaverse%20trading%20holographic%20charts%20green%20neon%20dark%20background%20futuristic%20financial%20technology%20cinematic&width=1200&height=630&seq=news-cover-005&orientation=landscape',
  },
  {
    id: 'meta66-006',
    title: 'META66 AI智能体平台MetaAgent 2.0发布：支持百亿参数本地部署',
    summary: 'META66发布MetaAgent 2.0平台，支持百亿参数AI模型在XR设备本地部署，实现完全离线的AI智能体交互，彻底解决元宇宙AI体验的隐私与延迟问题。',
    content: `META66今日发布MetaAgent 2.0平台，这是专为元宇宙场景设计的AI智能体开发与部署平台，最大突破是支持百亿参数AI模型在XR设备端本地部署。

**核心突破**

MetaAgent 2.0采用META66自研的MetaCompress量化压缩技术，可将百亿参数的大语言模型压缩至XR设备可承载的规模，同时保持95%以上的性能表现。这意味着：

1. 完全离线运行：无需网络连接，AI智能体在本地实时响应
2. 零延迟交互：消除了云端推理的网络延迟，实现真正的实时AI对话
3. 隐私保护：所有对话数据在本地处理，不上传云端
4. 个性化学习：AI智能体可在本地持续学习用户偏好，越用越懂你

**应用场景**

MetaAgent 2.0已在META66元宇宙平台内部署了超过1000个AI智能体角色，涵盖虚拟导游、AI教师、数字助理、虚拟伴侣等多种形态，日活跃交互次数超过5000万次。`,
    category: 'ai',
    tags: ['AI智能体', '大模型', '元宇宙AI', 'MetaAgent'],
    author: '刘宇航',
    authorAvatar: 'https://readdy.ai/api/search-image?query=AI%20researcher%20portrait%20professional%20dark%20background%20green%20neon%20accent%20futuristic&width=80&height=80&seq=avatar-006&orientation=squarish',
    publishDate: '2026-03-10',
    readTime: 7,
    views: 78300,
    cover: 'https://readdy.ai/api/search-image?query=AI%20agent%20robot%20holographic%20interface%20green%20neon%20dark%20background%20futuristic%20technology%20sci-fi%20cinematic&width=1200&height=630&seq=news-cover-006&orientation=landscape',
  },
  {
    id: 'meta66-007',
    title: '量子加密里程碑：META66量子密钥分发网络覆盖全国100个城市',
    summary: 'META66量子安全实验室宣布，基于量子密钥分发（QKD）技术的MetaShield量子加密网络正式覆盖全国100个主要城市，为元宇宙数字资产提供量子级安全保障。',
    content: `META66量子安全实验室今日宣布，MetaShield量子加密网络正式覆盖全国100个主要城市，这是全球规模最大的商用量子密钥分发网络，也是元宇宙安全基础设施的重大里程碑。

**技术原理**

量子密钥分发（QKD）利用量子力学的基本原理——量子态不可克隆定理——实现理论上无法被破解的加密通信。任何窃听行为都会不可避免地改变量子态，从而被立即检测到。

**网络规模**

MetaShield量子加密网络目前包括：
- 100个城市节点，覆盖全国主要经济区
- 超过10,000公里的量子光纤骨干网
- 128个量子中继站
- 每秒可生成超过100万个量子密钥对

**应用场景**

目前，MetaShield已为META66平台内超过500万个高价值数字资产账户提供量子级安全保护，包括虚拟土地、稀有数字藏品、企业级数字孪生资产等。`,
    category: 'quantum',
    tags: ['量子加密', 'QKD', '网络安全', '元宇宙安全'],
    author: '赵量子',
    authorAvatar: 'https://readdy.ai/api/search-image?query=quantum%20physicist%20portrait%20professional%20dark%20background%20green%20neon%20accent&width=80&height=80&seq=avatar-007&orientation=squarish',
    publishDate: '2026-03-05',
    readTime: 8,
    views: 43600,
    cover: 'https://readdy.ai/api/search-image?query=quantum%20encryption%20security%20shield%20particles%20glowing%20green%20dark%20background%20futuristic%20technology%20sci-fi%20cinematic%20wide&width=1200&height=630&seq=news-cover-007&orientation=landscape',
  },
  {
    id: 'meta66-008',
    title: '7G愿景白皮书发布：META66与ITU联合定义下一代超连接标准',
    summary: 'META66联合国际电信联盟（ITU）发布《7G愿景白皮书》，提出7G网络将实现1Tbps峰值速率、0.01ms延迟，并首次将元宇宙沉浸体验纳入核心设计目标。',
    content: `META66联合国际电信联盟（ITU）今日正式发布《7G愿景白皮书》，这是全球首份系统性定义7G网络标准的权威文件，标志着人类通信技术向下一个里程碑迈进。

**7G核心指标**

根据白皮书，7G网络将实现以下突破性指标：
- 峰值速率：1Tbps（较6G提升10倍）
- 端到端延迟：0.01ms（较6G降低10倍）
- 连接密度：每平方公里1亿设备
- 频谱效率：较6G提升5倍
- 能效：较6G提升100倍

**元宇宙原生设计**

7G的最大创新在于，首次将元宇宙沉浸体验纳入网络设计的核心目标。7G网络将原生支持：
- 全息通信：实时传输全息影像，实现"面对面"的远程交互
- 触觉互联网：传输触觉、嗅觉等多感官信息
- 脑机接口通信：支持脑波信号的实时传输与处理
- 数字孪生同步：实现物理世界与数字孪生的毫秒级同步

**时间表**

白皮书预计，7G标准将于2030年完成制定，2033年开始商用部署，2038年实现全球主要城市覆盖。META66将作为7G元宇宙应用的核心推动者，参与全程标准制定。`,
    category: '6g',
    tags: ['7G', '通信标准', 'ITU', '元宇宙通信'],
    author: '周通信',
    authorAvatar: 'https://readdy.ai/api/search-image?query=telecom%20engineer%20portrait%20professional%20dark%20background%20green%20neon%20accent&width=80&height=80&seq=avatar-008&orientation=squarish',
    publishDate: '2026-02-28',
    readTime: 10,
    views: 67900,
    cover: 'https://readdy.ai/api/search-image?query=7G%20network%20future%20communication%20holographic%20signal%20waves%20green%20neon%20dark%20background%20futuristic%20technology%20cinematic%20wide&width=1200&height=630&seq=news-cover-008&orientation=landscape',
  },
  {
    id: 'meta66-009',
    title: '脑机接口突破：META66 BCI设备实现每分钟1000字的意念输入',
    summary: 'META66脑机接口实验室发布最新研究成果，非侵入式BCI设备MetaMind实现每分钟1000字的意念文字输入速度，准确率达99.2%，创下全球新纪录。',
    content: `META66脑机接口实验室今日在《Nature》杂志发表重磅研究成果，非侵入式脑机接口设备MetaMind实现了每分钟1000字的意念文字输入速度，准确率高达99.2%，创下全球非侵入式BCI的新纪录。

**技术突破**

MetaMind采用META66自研的NeuroDecoder神经解码算法，通过分析大脑皮层的电磁信号模式，实时解码用户的意念内容。与此前技术相比，MetaMind的突破在于：

1. 速度：每分钟1000字，是此前最快纪录的3倍
2. 准确率：99.2%，达到实用化门槛
3. 非侵入：无需手术植入，佩戴舒适的头戴设备即可使用
4. 适应性：系统可在30分钟内完成个性化校准

**元宇宙应用**

在元宇宙场景中，MetaMind将彻底改变人机交互方式：用户无需手柄、键盘或语音，仅凭意念即可控制虚拟世界中的一切。META66预计将于2027年将MetaMind集成到MetaLens Pro的下一代产品中。`,
    category: 'metaverse',
    tags: ['脑机接口', 'BCI', '神经技术', '意念控制'],
    author: '林神经',
    authorAvatar: 'https://readdy.ai/api/search-image?query=neuroscientist%20portrait%20professional%20dark%20background%20green%20neon%20accent&width=80&height=80&seq=avatar-009&orientation=squarish',
    publishDate: '2026-02-20',
    readTime: 9,
    views: 112400,
    cover: 'https://readdy.ai/api/search-image?query=brain%20computer%20interface%20neural%20network%20holographic%20mind%20connection%20green%20neon%20dark%20background%20futuristic%20sci-fi%20cinematic&width=1200&height=630&seq=news-cover-009&orientation=landscape',
  },
  {
    id: 'meta66-010',
    title: 'META66数字孪生城市项目落地雄安：全球最大规模城市数字孪生正式运行',
    summary: 'META66与雄安新区管委会联合宣布，雄安数字孪生城市项目正式上线运行，实现对整个城市的实时1:1数字映射，成为全球规模最大的城市级数字孪生系统。',
    content: `META66与雄安新区管委会今日联合宣布，雄安数字孪生城市项目正式上线运行，这是全球规模最大的城市级数字孪生系统，实现了对整个雄安新区的实时1:1数字映射。

**系统规模**

雄安数字孪生城市系统的核心数据：
- 覆盖面积：1770平方公里（雄安新区全域）
- 数据采集点：超过500万个IoT传感器
- 数字孪生精度：厘米级（建筑物）/ 毫米级（关键基础设施）
- 实时同步延迟：&lt;100ms
- 数据处理量：每天超过10PB

**应用场景**

雄安数字孪生城市系统目前已在以下场景投入实际应用：
1. 城市规划：在数字孪生中模拟新建筑、道路对城市的影响
2. 应急管理：实时监控城市运行状态，提前预警潜在风险
3. 交通优化：基于实时数字孪生数据优化交通信号配时
4. 能源管理：精确预测和调度城市能源需求
5. 市民服务：市民可在元宇宙中"预览"城市未来规划

**未来展望**

META66计划在未来3年内，将数字孪生城市方案推广至全国50个主要城市，构建中国城市数字孪生网络，为智慧城市建设提供核心基础设施。`,
    category: 'metaverse',
    tags: ['数字孪生', '智慧城市', '雄安', 'IoT'],
    author: '吴城市',
    authorAvatar: 'https://readdy.ai/api/search-image?query=urban%20planner%20portrait%20professional%20dark%20background%20green%20neon%20accent&width=80&height=80&seq=avatar-010&orientation=squarish',
    publishDate: '2026-02-15',
    readTime: 11,
    views: 89200,
    cover: 'https://readdy.ai/api/search-image?query=digital%20twin%20smart%20city%20holographic%20projection%20real%20virtual%20mirror%20world%20green%20neon%20dark%20background%20futuristic%20cinematic%20wide&width=1200&height=630&seq=news-cover-010&orientation=landscape',
  },
  {
    id: 'meta66-011',
    title: 'Web4.0标准草案出炉：META66主导的空间语义网协议获国际认可',
    summary: 'META66主导研发的空间语义网协议（SSW）被纳入W3C Web4.0标准草案，这一协议将使元宇宙中的虚拟物体具备语义理解能力，实现真正的"智能元宇宙"。',
    content: `W3C（万维网联盟）今日发布Web4.0标准草案，META66主导研发的空间语义网协议（Spatial Semantic Web，SSW）被正式纳入草案核心章节，这标志着META66在下一代互联网标准制定中占据了重要地位。

**什么是Web4.0**

Web4.0是继Web3.0（去中心化语义网）之后的下一代互联网形态，其核心特征是：
- 空间化：互联网从二维平面扩展到三维空间
- 智能化：网络中的每个节点都具备AI推理能力
- 具身化：用户通过数字身体（Avatar）与网络交互
- 感知化：网络能够感知并响应物理世界的变化

**SSW协议的意义**

META66的空间语义网协议（SSW）解决了元宇宙中最核心的问题：如何让虚拟物体"理解"自己是什么、能做什么、与其他物体有什么关系。

有了SSW，元宇宙中的一把椅子不仅仅是一个3D模型，它还"知道"自己是椅子、可以被坐、属于某个房间、由某种材料制成……这种语义理解能力将使元宇宙从"视觉沉浸"升级为"认知沉浸"。`,
    category: 'web3',
    tags: ['Web4.0', '语义网', 'W3C', '元宇宙标准'],
    author: '郑标准',
    authorAvatar: 'https://readdy.ai/api/search-image?query=web%20standards%20expert%20portrait%20professional%20dark%20background%20green%20neon%20accent&width=80&height=80&seq=avatar-011&orientation=squarish',
    publishDate: '2026-02-10',
    readTime: 8,
    views: 52300,
    cover: 'https://readdy.ai/api/search-image?query=web4%20semantic%20network%20holographic%20nodes%20connections%20green%20neon%20dark%20background%20futuristic%20technology%20digital%20cinematic&width=1200&height=630&seq=news-cover-011&orientation=landscape',
  },
  {
    id: 'meta66-012',
    title: 'META66开发者生态突破100万：MetaSDK下载量创历史新高',
    summary: 'META66开发者平台注册开发者数量正式突破100万，MetaSDK累计下载量超过5000万次，元宇宙应用商店上架应用突破10万款，生态繁荣度全球领先。',
    content: `META66开发者平台今日宣布，注册开发者数量正式突破100万大关，MetaSDK累计下载量超过5000万次，元宇宙应用商店（MetaStore）上架应用突破10万款，这三项核心指标均创历史新高，标志着META66开发者生态进入爆发式增长阶段。

**生态数据**

- 注册开发者：100万+（同比增长320%）
- MetaSDK下载量：5000万次（累计）
- MetaStore上架应用：10万款
- 开发者月均收入：12,000元（中位数）
- 顶级开发者年收入：超过1000万元

**开发者激励计划**

为进一步激励开发者生态，META66宣布升级开发者激励计划：
1. 收入分成：平台抽成从30%降至15%
2. 流量扶持：新上架应用前3个月享受免费流量推广
3. 技术支持：提供7×24小时专属技术支持
4. 创业基金：设立10亿元元宇宙创业基金，支持优质开发者团队

**明星应用案例**

MetaStore中已涌现出多款月流水过千万的明星应用，包括虚拟演唱会平台MetaConcert、元宇宙教育平台MetaEdu、虚拟办公平台MetaOffice等，证明元宇宙应用已具备强大的商业变现能力。`,
    category: 'metaverse',
    tags: ['开发者生态', 'SDK', '元宇宙应用', '创业'],
    author: 'META66编辑部',
    authorAvatar: 'https://readdy.ai/api/search-image?query=developer%20community%20manager%20portrait%20professional%20dark%20background%20green%20neon%20accent&width=80&height=80&seq=avatar-012&orientation=squarish',
    publishDate: '2026-02-05',
    readTime: 6,
    views: 71500,
    cover: 'https://readdy.ai/api/search-image?query=developer%20ecosystem%20code%20holographic%20interface%20green%20neon%20dark%20background%20futuristic%20technology%20programming%20cinematic&width=1200&height=630&seq=news-cover-012&orientation=landscape',
  },
];
